type GapiType = typeof gapi;
type ResolveGapi = () => GapiType;

class GoogleOauthService {
  private readonly resolveGapi: ResolveGapi;
  private readonly clientId: string;
  private readonly scope: string;

  constructor({ resolveGapi, clientId, scope }: { resolveGapi: ResolveGapi; clientId: string; scope: string }) {
    this.resolveGapi = resolveGapi;
    this.clientId = clientId;
    this.scope = scope;

    this.initialize();
  }

  public async authenticate(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      let code: string;
      this.resolveGapi().auth2.authorize(
        {
          client_id: this.clientId,
          scope: this.scope,
          response_type: 'code',
          prompt: 'select_account',
          include_granted_scopes: true,
        },
        function (response) {
          if (response.error) {
            console.warn(response.error);
            reject(new Error('Google authentication is canceled'));
          }
          code = response.code;
          resolve(code);
        },
      );
    });
  }

  private initialize() {
    const api = this.resolveGapi();
    if (!api) {
      throw new Error('googleapi SDK is not loaded.');
    }
    api.load('auth2', () => {});
  }
}

export default GoogleOauthService;
